// TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
/**
 * Dado de leitura do Resumo para Aprovação, resolvido a partir de
 * `dados-simulados.json`.
 *
 * NENHUMA DATA LITERAL. O JSON guarda a distância em meses até hoje
 * (`competenciaAtras`) e, no ateste previsto, o mês (também em `mesesAtras`) e
 * o dia. Este arquivo monta a competência (`AAAA-MM`), o período (primeiro e
 * último dia do mês dela, como o mock sempre mostrou), o ateste previsto e o
 * identificador da medição (`med-AAAA-MM-NNN`, que embute a competência da
 * própria linha). As duas competências do mock continuam consecutivas: a mais
 * recente é a de dois meses atrás e a anterior a ela, a de três. Ano-mês
 * escrito à mão envelhece sozinho (CLAUDE.md, "Nenhuma competência literal no
 * mock"); `dadosSimulados.spec.ts` falha se alguém escrever um no JSON.
 */

import {
  anoMesAtras,
  dataAtras,
  primeiroDiaDoMesAtras,
  ultimoDiaDoMesAtras,
  type DiaRelativo,
} from '../datasRelativas';
import DADOS_SIMULADOS from './dados-simulados.json';

interface LinhaBruta {
  sequencia: number;
  contrato: string;
  dreId: string;
  dreCodigo: string;
  dreNome: string;
  tipo: string;
  tipoLabel: string;
  processoSei: string | null;
  valor: number;
  credenciadoNome: string;
  statusLote: string;
  competenciaAtras: number;
  atestePrevisto: DiaRelativo;
}

export function carregarResumoAprovacao(hoje = new Date()) {
  return (DADOS_SIMULADOS as LinhaBruta[]).map(
    ({ sequencia, competenciaAtras, atestePrevisto, ...linha }) => {
      const competencia = anoMesAtras(competenciaAtras, hoje);
      return {
        id: `med-${competencia}-${String(sequencia).padStart(3, '0')}`,
        ...linha,
        competencia,
        periodoInicio: primeiroDiaDoMesAtras(competenciaAtras, hoje),
        periodoFim: ultimoDiaDoMesAtras(competenciaAtras, hoje),
        atestePrevisto: dataAtras(atestePrevisto, hoje),
      };
    },
  );
}

export const DADOS_RESUMO_APROVACAO = carregarResumoAprovacao();
